import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=3151cdae&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=3151cdae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3151cdae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3151cdae')) {
      api.createRecord('3151cdae', component.options)
    } else {
      api.reload('3151cdae', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=3151cdae&scoped=true&", function () {
      api.rerender('3151cdae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27h8jJt44N02G/JS/comp/PopupBox.vue"
export default component.exports